import { EventImageDetailModel } from './event.image.detail.model';
export class PagedEventImageDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: EventImageDetailModel[] = [];
}
